import React, { useRef } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { Grid, Dialog, Button, SubmitButton, DatePicker, TimePicker, HorizontalStepperTemplate } from "../../../../../";
import { makeStyles } from "@material-ui/styles";
import { TextField } from "formik-material-ui";
import { Debug } from "../../../../../Molecules/Forms/Debug";
import { Divider, Typography } from "@material-ui/core";
var userSchema = Yup.object().shape({
  name: Yup.string().required("Campo obligatorio"),
  dob: Yup.string().required(),
  allergies: Yup.string(),
  comments: Yup.string(),
  parents: Yup.array().of(Yup.object().shape({
    name: Yup.string().required(),
    kinship: Yup.string().required(),
    email: Yup.string().required(),
    phone: Yup.string().required()
  })).min(1)
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      marginRight: "30px"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end"
    },
    flex: {
      display: "flex"
    },
    divider: {
      margin: "4px 0"
    },
    actionsParent: {
      display: "flex",
      alignItems: "center"
    }
  };
});

var DialogCampusSingleAddUser = function DialogCampusSingleAddUser(props) {
  var initialValues = {
    name: "",
    dob: null,
    allergies: "",
    comments: "",
    groups: [],
    parents: [{
      name: "",
      kinship: "",
      email: "",
      phone: ""
    }]
  };
  var stepperRef = useRef();

  var handlePreviousStepper = function handlePreviousStepper() {
    stepperRef.current.handleActionStepper("previous_step");
  };

  var handleNextStepper = function handleNextStepper() {
    stepperRef.current.handleActionStepper("next_step");
  };

  var handleClose = function handleClose() {
    stepperRef.current.handleActionStepper("reset");
    props.onClose();
  };

  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: props.translation ? props.translation.title || "Add user" : "Add user",
    open: props.open,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: userSchema,
    onSubmit: function onSubmit(values) {
      props.onSubmit(values);
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(HorizontalStepperTemplate, {
        ref: stepperRef,
        steps: props.translation ? props.translation.steps || ["Step 1", "Step 2"] : ["Step 1", "Step 2"],
        contentSteps: [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
          name: "name",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 6
        }, /*#__PURE__*/React.createElement(Field, {
          component: DatePicker,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.dob || "Birthday Date" : "Birthday Date" : "Birthday Date",
          name: "dob",
          fullWidth: true,
          disableFuture: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 12
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.allergies || "Allergies" : "Allergies" : "Allergies",
          name: "allergies",
          variant: "outlined",
          fullWidth: true,
          type: "text",
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 12
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          type: "text",
          label: props.translation ? props.translation.inputs ? props.translation.inputs.comments || "Comments" : "Comments" : "Comments",
          name: "comments",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        }))), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(FieldArray, {
          name: "parents",
          render: function render(_ref2) {
            var insert = _ref2.insert,
                remove = _ref2.remove,
                push = _ref2.push;
            return values.parents.length > 0 ? values.parents.map(function (field, index, arr) {
              return /*#__PURE__*/React.createElement(Grid, {
                container: true,
                alignItems: "center",
                spacing: 2,
                key: index
              }, /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.actionsParent
              }, /*#__PURE__*/React.createElement(Typography, {
                variant: "body1",
                className: classes.mr30
              }, props.translation ? props.translation.texts ? props.translation.texts.responsable || "Responsable" : "Responsable" : "Responsable"), /*#__PURE__*/React.createElement(Button, {
                key: "delete",
                className: classes.button,
                disabled: values.parents.length === 1,
                type: "button",
                color: "secondary",
                variant: "outlined",
                onClick: function onClick() {
                  return remove(index);
                }
              }, "-")), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 6
              }, /*#__PURE__*/React.createElement(Field, {
                name: "parents[".concat(index, "].name"),
                key: "parents[".concat(index, "].name"),
                label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
                component: TextField,
                margin: "normal",
                fullWidth: true,
                type: "text",
                variant: "outlined"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 6
              }, /*#__PURE__*/React.createElement(Field, {
                name: "parents[".concat(index, "].kinship"),
                key: "parents[".concat(index, "].kinship"),
                label: props.translation ? props.translation.inputs ? props.translation.inputs.kinship || "Kinship" : "Kinship" : "Kinship",
                component: TextField,
                margin: "normal",
                fullWidth: true,
                type: "text",
                variant: "outlined"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 6
              }, /*#__PURE__*/React.createElement(Field, {
                name: "parents[".concat(index, "].email"),
                key: "parents[".concat(index, "].email"),
                label: props.translation ? props.translation.inputs ? props.translation.inputs.email || "Email" : "Email" : "Email",
                component: TextField,
                margin: "normal",
                fullWidth: true,
                type: "email",
                variant: "outlined"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 6
              }, /*#__PURE__*/React.createElement(Field, {
                name: "parents[".concat(index, "].phone"),
                key: "parents[".concat(index, "].phone"),
                label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Phone" : "Phone" : "Phone",
                component: TextField,
                margin: "normal",
                fullWidth: true,
                type: "text",
                variant: "outlined"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 2
              }, arr.length - 1 === index && /*#__PURE__*/React.createElement(Button, {
                key: "add",
                type: "button",
                className: classes.mt8,
                size: "small",
                color: "primary",
                variant: "outlined",
                onClick: function onClick() {
                  return push({
                    name: "",
                    kinship: "",
                    phone: "",
                    email: ""
                  });
                }
              }, props.translation ? props.translation.buttons ? props.translation.buttons.add_responsable || "Add responsable" : "Add responsable" : "Add responsable")), arr.length > 1 && arr.length - 1 !== index && /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12
              }, /*#__PURE__*/React.createElement(Divider, {
                className: classes.divider
              })));
            }) : /*#__PURE__*/React.createElement(Button, {
              key: "add",
              type: "button",
              className: classes.mr30,
              size: "small",
              color: "primary",
              variant: "outlined",
              onClick: function onClick() {
                return push({
                  name: "",
                  kinship: "",
                  phone: "",
                  email: ""
                });
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.add_responsable || "Add responsable" : "Add responsable" : "Add responsable");
          }
        })))],
        actionsSteps: [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: props.onClose
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          disabled: !values.name && !values.dob,
          onClick: handleNextStepper,
          type: "submit"
        }, props.translation ? props.translation.buttons ? props.translation.buttons.next || "Next" : "Next" : "Next")), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: handlePreviousStepper
        }, props.translation ? props.translation.buttons ? props.translation.buttons.back || "Back" : "Back" : "Back"), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, props.translation ? props.translation.buttons ? props.translation.buttons.save || "Save" : "Save" : "Save"))]
      }));
    }
  }));
};

export { DialogCampusSingleAddUser };